import { Map } from 'immutable';
import { combineReducers } from 'redux-immutable'
import eventsReducer from './eventsReducer';
import settingsReducer from './settingsReducer';

const INIT_STATE = Map();

const combinedReducer = combineReducers({
    settings: settingsReducer,
    events: eventsReducer,
});

const eventDataReducer = (state = INIT_STATE, action) => combinedReducer(state, action)

export default eventDataReducer;